module.exports = "<element-selector data=\"data\" on-select=\"onSelect\"></element-selector>\n"